import { render } from "./ApplyTariffToListTable.vue?vue&type=template&id=1ad31e6d"
import script from "./ApplyTariffToListTable.vue?vue&type=script&lang=js"
export * from "./ApplyTariffToListTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__